const MANDRILL_ACTIVITY_URL = "https://mandrillapp.com/activity"

// Subjects are templated; Mandrill stores the rendered subject, so anything from
// the first placeholder onwards would never match a real send.
const PLACEHOLDER_MARKERS = ["{{", "*|", "${", "<%", "%recipient"]

export function searchableSubject(subject: string | null): string | null {
  if (!subject) return null
  const cut = PLACEHOLDER_MARKERS.reduce((earliest, marker) => {
    const index = subject.indexOf(marker)
    return index === -1 ? earliest : Math.min(earliest, index)
  }, subject.length)
  return subject.slice(0, cut).trim() || null
}

/** Null when the subject starts with a placeholder, leaving nothing to search. */
export function mandrillActivityUrl(subject: string | null): string | null {
  const searchable = searchableSubject(subject)
  if (!searchable) return null
  return `${MANDRILL_ACTIVITY_URL}?q=subject:${encodeURIComponent(
    `"${searchable}"`,
  )}`
}
